import { koKR } from "@clerk/localizations";

// Clerk 한국어 localization 확장
export const customKoKR = {
  ...koKR,
  formFieldLabel__username: "닉네임",
  formFieldInputPlaceholder__username: "영어로만 입력해주세요",
  formFieldError__username: "닉네임에는 영어만 사용할 수 있습니다",
  formFieldError__username_invalid_character:
    "사용자 이름에는 영어 문자만 사용할 수 있습니다",
  formFieldError__username_invalid_format:
    "올바른 형식이 아닙니다. 영어만 사용해주세요",
  userProfile: {
    ...koKR.userProfile,
    start: {
      ...koKR.userProfile?.start,
      usernameSection: {
        title: "닉네임",
        primaryButton__setUsername: "닉네임 설정",
        primaryButton__updateUsername: "닉네임 변경",
      },
    },
  },
  signUp: {
    ...koKR.signUp,
    continue: {
      ...koKR.signUp?.continue,
      actionLink: "로그인",
      actionText: "이미 계정이 있으신가요?",
      subtitle: "계속하려면 나머지 상세 정보를 입력해 주세요.",
      title: "누락된 정보 입력",
    },
  },
};

// 사용자 이름 유효성 검사 함수
export const validateUsername = (username: string): boolean => {
  // 영어 알파벳과 숫자, 언더스코어, 하이픈만 허용
  const englishOnlyRegex = /^[a-zA-Z0-9_-]+$/;
  return englishOnlyRegex.test(username);
};

// 사용자 이름 유효성 검사 에러 메시지
export const getUsernameErrorMessage = (username: string): string => {
  if (!validateUsername(username)) {
    return "사용자 이름에는 영어, 숫자, 언더스코어(_), 하이픈(-)만 사용할 수 있습니다";
  }
  return "";
};
